// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3a2Be","productName":"Table_productName__2JxW3"};